export var Entities = {
    LINK: 'LINK',
    NEW_LINE: 'BR',
    NON_BREAKING_SPACE: 'NONBREAKSPACE',
};
